<template>
  <router-view />
</template>

<script>
export default {
  name: 'MainApp',
}
</script>
